import i18n from "../../i18n";

// Widget types the add drawer can create. `needsTag` = the Tag step applies. `label` is a getter (selected language).
const view = (type, w, h, needsTag) => ({ get label() { return i18n.t(`home.views.${type}`); }, w, h, needsTag });
export const VIEWS = {
  gauge: view("gauge", 3, 3, true),
  kpi: view("kpi", 3, 2, true),
  linechart: view("linechart", 6, 3, true),
  table: view("table", 6, 4, true),
  statuscard: view("statuscard", 3, 2, true),
  alarm_table: view("alarm_table", 5, 4, false),
  anomaly_table: view("anomaly_table", 5, 4, false),
  event_feed: view("event_feed", 6, 4, false),
  edge_system: view("edge_system", 4, 2, false),
  edge_logs: view("edge_logs", 12, 5, false),
};

export const needsTag = (type) => !!VIEWS[type]?.needsTag;

// Generated titles are stored with the widget, so they are written in the language selected when the widget is added.
const edgeTitle = (type) => i18n.t(`home.titles.${type}`);

/** draft → dashboard widget. `index` = current widget count (grid slot). */
export function buildWidget({ id, type, edge, deviceIds = [], tagNames = [], deviceNames = "", tagLabels = "", range, min, max, title, index = 0 }) {
  const v = VIEWS[type];
  const position = { x: (index % 4) * 3, y: Math.floor(index / 4) * 3, w: v.w, h: v.h };
  const edgeName = edge.name ?? edge.edgeId ?? "Edge";
  if (!v.needsTag) {
    return {
      id,
      type,
      position,
      config: { edgeId: edge.edgeId, title: title || `${edgeName} · ${edgeTitle(type)}`, ...(type === "edge_logs" ? { range: "1h" } : null) },
    };
  }
  const hasRange = type === "linechart" || type === "table";
  return {
    id,
    type,
    position,
    config: {
      edgeId: edge.edgeId,
      deviceIds: [...deviceIds],
      tagNames: [...tagNames],
      title: title || `${edgeName} · ${deviceNames} · ${tagLabels}`,
      range: hasRange ? range : undefined,
      // gauge: absent min/max = auto range from the last 24h
      ...(type === "gauge" && min != null && max != null ? { min, max } : null),
    },
  };
}
